export const environment = {
  production: false,
  appsScriptUrl: 'https://script.google.com/macros/s/AKfycbxGwRTC-I3l9Ij7YvPZ2EKSm8zu80bVdLEMxoHzUJaIt8wQDZhb92gCt-31R42d2-Oi/exec',
  googleClientId: '90916419426-i96b59kr47gd2mb4mlirc0vpj4jrqljk',
  clubName: '[DEVELOP] OURS Judo Club Fitness',
  logoFile: 'logo-ours.png',
  dossierPrefix: 'OURS',
};
